import styled from 'styled-components';

export const Container = styled.div`
  background: transparent;
  display: flex;
  justify-content: flex-start;
  border-radius: 100px;
  align-items: center;
  position: relative;
  height: 3px;
  width: 100%;
`;

export const Progress = styled.div<{ value: number }>`
  transition: width 0.3s ease-in-out;
  border-radius: 100px;
  background: ${({ theme }) => theme.configs.CTAButton.bgColor};
  height: 3px;
  width: ${({ value }) => value}%;
`;
